import { render, staticRenderFns } from "./aLteAsideBrand.vue?vue&type=template&id=362fea5c"
import script from "./aLteAsideBrand.vue?vue&type=script&lang=js"
export * from "./aLteAsideBrand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dem/Go/src/github.com/demget/quadroclub/web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('362fea5c', component.options)
    } else {
      api.reload('362fea5c', component.options)
    }
    module.hot.accept("./aLteAsideBrand.vue?vue&type=template&id=362fea5c", function () {
      api.rerender('362fea5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/aside/aLteAsideBrand.vue"
export default component.exports